<template>
  <div class="hh">
    <div class="floatingView pointer" ref="showDoc" @click.stop="floatingTap"></div>
  </div>
</template>

<script type="es6">
export default {
  name: 'goHome',
  mixins: [],
  data() {
    return {
      isMobile: false,
    }
  },
  props: {
  },
  created() {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    this.isMobile = mobile ? true : false
  },
  methods: {
    floatingTap(el) {
      let isClick = el.target.parentNode.getAttribute('flag')
      if(isClick ==='false') return false
      let drag = el.target.parentNode.getAttribute('drag')
      if (drag === 'no') {
        el.target.parentNode.setAttribute('drag', null)
        el.target.parentNode.classList.add('acc')
        return false
      }
      let token = this.commonJs.getQueryString('token') || localStorage['token']
      let h5Href = ''
      let branchId = localStorage['branchId'] ? localStorage['branchId'] : ''
      let locationHost = window.location.host
      if (locationHost.includes('localhost') || locationHost.includes('80')) {
        h5Href = `http://localhost:8081/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
      } else {
        if (window.location.href.includes('https')) {
          h5Href = `https://${locationHost}/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
        } else {
          h5Href = `http://${locationHost}/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
        }
      }
      window.location.href = h5Href
    },
  },
}
</script>

<style lang='scss' scoped>
.hh {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  z-index: 99;
  animation: all 5s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.floatingView {
  background: url('../../../static/images/h5HomeIcon.png') #fff;
  background-size: cover;
  width: 68px;
  height: 68px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/goHome.vue